import firebase from 'firebase/app';

let analytics: firebase.analytics.Analytics | null = null;

const cfg = {
	apiKey: 'AIzaSyAREmC2G9xTeaZxCnix2Y5TJLzXkWNKn-I',
	authDomain: 'supportintel-landing-page.firebaseapp.com',
	projectId: 'supportintel-landing-page',
	storageBucket: 'supportintel-landing-page.appspot.com',
	messagingSenderId: '414528680871',
	appId: '1:414528680871:web:e854720523c27241e33c82',
	measurementId: 'G-LN5KXD3VHX',
};

async function ensureAnalytics() {
	if (typeof window === 'undefined') return null;
	const app = firebase.apps.find((a) => a.name === 'analyticsApp') || firebase.initializeApp(cfg, 'analyticsApp');

	if (!('analytics' in firebase)) {
		await import('firebase/analytics');
	}
	analytics = firebase.analytics(app);
	return analytics;
}

export async function logEvent(name: string, params?: Record<string, any>) {
	if (!analytics) await ensureAnalytics();
	analytics?.logEvent(name, params);
}

export async function pingAnalytics() {
	await logEvent('debug_test_event', { debug_mode: 1 });
}
// usage
// useEffect(() => {
// 	pingAnalytics();
// }, []);
